import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
// import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs'; // Hidden — tabs removed
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowLeft, Search } from 'lucide-react';
import DirectCommissionTable from './DirectCommissionTable';
// import TieredCommissionTable from './TieredCommissionTable'; // Hidden — Tiered tab not shown
import SubDistributorDialog from './SubDistributorDialog';
import { userService } from '../../../_services';

function CommissionTrackingView({ onBack }) {
  // State
  // const [activeTab, setActiveTab] = useState('direct'); // Hidden — tabs removed
  const [selectedMonth, setSelectedMonth] = useState('');
  const [monthOptions, setMonthOptions] = useState([]);
  const [loadingMonths, setLoadingMonths] = useState(true);
  const [loadingTableData, setLoadingTableData] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [showSubDistDialog, setShowSubDistDialog] = useState(false);
  const [selectedDistributor, setSelectedDistributor] = useState(null);

  // Fetch month/year data on mount
  useEffect(() => {
    fetchMonthYearData();
  }, []);

  const fetchMonthYearData = async () => {
    try {
      const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
      const [userId, userName] = Usermeta_Data.split(':');
      
      const response = await userService.GetMonthYear(userId, userName);
      
      if (response && response.length > 0) {
        // API returns [{ monthYearname: "June,2024" }, ...] — split into month/year
        const parsed = response.map(item => {
          const parts = item.monthYearname.split(',');
          return {
            monthYearname: item.monthYearname,
            month: parts[0],
            year: parts[1]
          };
        });
        setMonthOptions(parsed);
        // Set first month as default (combined "month,year" string)
        setSelectedMonth(parsed[0].monthYearname);
      }
    } catch (error) {
      console.error('Error fetching month/year data:', error);
    } finally {
      setLoadingMonths(false);
    }
  };

  const handleDistributorClick = (distributor, dateMonth) => {
    setSelectedDistributor({ ...distributor, dateMonth });
    setShowSubDistDialog(true);
  };

  return (
    <div className="w-full space-y-6">
      {/* Back Button */}
      <Button variant="outline" onClick={onBack} className="self-start">
        <ArrowLeft className="h-4 w-4" />
        Back to Reports
      </Button>

      {/* Heading */}
      <h1 className="text-3xl font-bold tracking-tight text-foreground">Commission Tracking</h1>

      {/* Filters Card */}
      <Card>
        <CardContent className="pt-6">
          <div className="flex flex-col sm:flex-row gap-3">
            <div className="relative flex-1 sm:max-w-xs">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
              <Input 
                placeholder="Search by name or email..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                className="pl-9 pr-9"
                disabled={loadingMonths || loadingTableData}
              />
            </div>
            <Select value={selectedMonth} onValueChange={setSelectedMonth} disabled={loadingMonths || loadingTableData}>
              <SelectTrigger className="w-full sm:w-[200px]">
                <SelectValue placeholder="Select month" />
              </SelectTrigger>
              <SelectContent>
                {monthOptions.map((option, index) => (
                  <SelectItem 
                    key={index} 
                    value={option.monthYearname}
                  >
                    {option.month} {option.year}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </CardContent>
      </Card>

      {/* Direct Commission Table */}
      <DirectCommissionTable
        searchText={searchText}
        selectedMonth={selectedMonth}
        onRowClick={handleDistributorClick}
        onLoadingChange={setLoadingTableData}
      />

      {/* Hidden — Tabs removed; only Direct Commission shown
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList>
          <TabsTrigger value="direct">Direct Commission</TabsTrigger>
          <TabsTrigger value="tiered">Tiered Commission</TabsTrigger>
        </TabsList>
        <TabsContent value="direct">
          <DirectCommissionTable searchText={searchText} selectedMonth={selectedMonth} onRowClick={handleDistributorClick} />
        </TabsContent>
        <TabsContent value="tiered">
          <TieredCommissionTable searchText={searchText} selectedMonth={selectedMonth} onRowClick={handleDistributorClick} />
        </TabsContent>
      </Tabs>
      */}

      {/* Sub-Distributor Dialog */}
      <SubDistributorDialog
        open={showSubDistDialog}
        onOpenChange={setShowSubDistDialog}
        distributor={selectedDistributor}
      />
    </div>
  );
}

export default CommissionTrackingView;
